import React from "react";

const LoginPromptModal = ({ open, onClose, onLogin }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      {/* modal box */}
      <div className="relative bg-white w-[90%] max-w-sm rounded-xl p-6 shadow-xl text-center animate-fadeIn">
        <h2 className="text-xl font-semibold text-[#6B4226]">
          Login Required
        </h2>

        <p className="text-sm text-gray-600 mt-2">
          You need to login to continue this action.
        </p>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onLogin}
            className="flex-1 bg-[#6B4226] text-white py-2 rounded-md hover:opacity-90"
          >
            Login
          </button>

          <button
            onClick={onClose}
            className="flex-1 border border-gray-300 py-2 rounded-md hover:bg-gray-100"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;